import { PipesModule } from 'src/app/pipes/pipes.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { MainComponent } from './main/main.component';
import { AppRoutingModule } from '../app-routing.module';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TranslateModule } from "@ngx-translate/core";
import { NavComponent } from './nav/nav.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    MainComponent,
    UserMenuComponent,
    SidebarComponent,
    NavComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    TranslateModule,
    SharedModule,
    NgbModule,
    PipesModule
  ],
  exports: [
    MainComponent,
    HeaderComponent
  ]
})
export class LayoutModule { }
